import React from 'react';
import SafeIcon from '../common/SafeIcon';

export default function Header() {
  return (
    <header className="site-header">
      <div className="header-inner">
        <a href="/" aria-label="Cálcio corrigido, página inicial" className="brand logo"><svg viewBox="0 0 32 32" width="28" height="28" aria-hidden="true" focusable="false"><rect x="5" y="6" width="7" height="20" fill="currentColor"/><rect x="15" y="12" width="5" height="14" fill="currentColor" opacity=".5"/><rect x="22" y="9" width="5" height="17" fill="var(--logo-accent)"/></svg><span>Cálcio corrigido</span></a>
        <span className="header-note">Ferramenta educativa</span>
      </div>
    </header>
  );
}
